import BaseEnum from "./base_enum.js";

class IdentificationStatusEnumDesc extends BaseEnum {

  name() {
    return "identification_status";
  }

  rawValues() {
    return ["unidentified", "identification_required", "identification_pending", "identified"];
  }

}

const IdentificationStatusEnum = new IdentificationStatusEnumDesc();
export default IdentificationStatusEnum;